import { render, staticRenderFns } from "./iovation-field.vue?vue&type=template&id=1448b14b"
import script from "./iovation-field.ts?vue&type=script&lang=ts&external"
export * from "./iovation-field.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports